import { LineString } from "geojson"
import { FlightlineStatusOption } from "../store/types/MissionsTypes"
import { ReviewNode } from "./MissionReview"

export const flightLineEventId: keyof FlightlineEvent = "fe_event_id"

interface FlightlineEventBase {
    flight_line_event_id?: number
    line_original_name: string
    /**
     * Sensor Label
     */
    coll_event_name: string
    flight_line_start_time: string
    flight_line_stop_time: string
    flight_line_distance: number
    flight_line_duration: number
    flown_agl: number
    flight_status?: FlightlineStatusOption
    mission_id: number | null
    notes: string
    sensor_details?: string | null
    shape?: string
    node_events?: ReviewNode[]
    angle_degrees?: number
    geojson?: LineString
    event_distance_nmi?: number
}

// The GET and PUT Dto for flightline events
export interface FlightlineEventDTO extends FlightlineEventBase {
    /**
     * this version only has actual planned_line_id entries and no unplannedLineValue
     */
    planned_line_ids: number[]
}

export interface FlightlineEvent extends FlightlineEventBase {
    /**
     * Fe only
     */
    fe_event_id: number
    fe_name_from_original?: string
    // made as a separate array so we can add unplanned line number to it safely
    fe_planned_line_ids: number[]
}

export interface EventRegexExpression {
    active: string
    custom: string
    selectedTemplate: EventRegexTemplate
    isCustom: boolean
}

export interface EventRegexTemplate {
    label: string
    description?: string
    value: string
}

export const regexTemplateOptions: EventRegexTemplate[] = [
    { label: "Riegl Record Naming", description: "(RecordXXX_LineXXX)", value: "Record\\d+_Line(\\d+)" },
    { label: "Chiroptera Record Naming", description: "(FLXXX)", value: "FL(\\d+)" },
    { label: "UltraCam Record Naming", description: "(Run_XXX)", value: "Run_(\\d+)" },
    { label: "Leica FlightData Naming", description: "(XXX)", value: "^(\\d+)$" },
]
